// extracted by mini-css-extract-plugin
export default {"main":"b28fa9ec97 f2fbcc1e73 _72836db446 _725a53aa48","title":"_17b2c8a389"};